module.exports = __webpack_public_path__ + "img/about_a02.e0ad8d4e.svg";